import React, { ReactElement } from 'react';

export interface IfProps extends React.PropsWithChildren {
  condition?: boolean;
  alwaysRender?: boolean;
}

const If: React.FC<IfProps> = ({ condition, alwaysRender, children }) => {
  if (alwaysRender) {
    return <div>{condition && children}</div>;
  }

  if (condition) {
    return children as ReactElement;
  }

  return null;
};

export default React.memo(If);
